import { useEffect, useRef } from "react";
import { EvesInsights } from "../components/chat/EvesInsights";
import { D2C_HOME_INSIGHTS } from "../components/chat/insightsData";
import { PersonalizedGreeting } from "../components/chat/PersonalizedGreeting";
import { Header } from "../components/Header";
import { HomeEducationSuggestions } from "../components/home/HomeEducationSuggestions";
import { SessionGuard } from "../components/SessionGuard";
import { useJourneyOverallProgress } from "../hooks/useJourneyOverallProgress";
import { useUser } from "../hooks/useUser";
import { useUserType } from "../hooks/useUserType";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./HomePage.module.css";

function HomePageContent() {
	const { logHome } = useAnalytics();
	const hasTrackedPageView = useRef(false);
	const { data: userData, isLoading: userLoading } = useUser();
	const { isD2C } = useUserType();
	const { t } = useClientTranslations("common");
	// Real journey progress for the greeting ring + "X more tasks" subtitle (clinic
	// users only — the ring is hidden for D2C). Computed from the user's journey,
	// not fixed numbers.
	const { percent: journeyPercent, remainingTasks } =
		useJourneyOverallProgress();

	useEffect(() => {
		if (!hasTrackedPageView.current) {
			hasTrackedPageView.current = true;
			logHome("page_viewed");
		}
	}, [logHome]);

	if (userLoading || !userData) {
		return (
			<div className={styles.container}>
				<Header />
				<main className={styles.main} />
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<Header />
			<main className={styles.main}>
				<PersonalizedGreeting
					user={userData}
					showProgressCircle={!isD2C}
					progressPercent={journeyPercent}
					taskCount={remainingTasks}
					subtitle={isD2C ? t("home.d2cGreetingSubtitle") : undefined}
				/>
				<EvesInsights homeInsights={isD2C ? D2C_HOME_INSIGHTS : undefined} />
				{isD2C && <HomeEducationSuggestions />}
			</main>
		</div>
	);
}

export function HomePage() {
	return (
		<SessionGuard>
			<HomePageContent />
		</SessionGuard>
	);
}
